import { HttpHeaders } from '@angular/common/http';

export function resolveFileName(headers: HttpHeaders): string {
  const contentDisposition = headers.get('Content-Disposition');
  return contentDisposition.split(';')[1].trim().split('=')[1].replace(/"/g, '');
}
